import { css } from 'styled-system/css';

export const bookingBetContainerStyle = {
	container: css({
		base: {
			mt: '9px'
		},
		_mars: {
			borderColor: 'booked.2_50',
			userSelect: 'none',
		}
	}),
	title: css({
		_mars: {
			color: 'black.1',
		},
	}),
}